// extracted by mini-css-extract-plugin
var _1 = "RectangleElement_root__b3dfd";
export { _1 as "root" }
